<template>
  <div id="app">
    <section class="hero is-primary is-bald">
      <!-- Hero header: will stick at the top -->
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <a class="navbar-item">
            ЦУП
          </a>

          <button class="button navbar-burger">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div class="navbar-end">
          <b-dropdown v-model="navigation" position="is-bottom-left">
            <a class="navbar-item" slot="trigger">
              <span>Пользователь</span>
              <b-icon icon="menu-down"></b-icon>
            </a>

            <b-dropdown-item custom>
              В сети как <b>{{ current_user }}</b>
            </b-dropdown-item>
            <hr class="dropdown-divider">
            <b-dropdown-item value="logout" @click='logout()'>
              <b-icon icon="logout"></b-icon>
              Выйти
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </nav>
      <!-- Hero content: will be in the middle -->
      <!-- <div class="hero-body">

        <div class="container has-text-centered">
          <h1 class="title">
            Menus
          </h1>
          <h2 class="subtitle">
            Test admin station
          </h2>
        </div>

      </div> -->

      <!-- Hero footer: will stick at the bottom -->
      <div class="hero-foot">
        <nav class="tabs  is-boxed">
          <div class="container">
            <ul>
              <li :class='active_tab_class("main_page")'><router-link :to="{ path: 'home' }"><b-icon icon="home"></b-icon></router-link></li>
              <li :class='active_tab_class("users")'><router-link :to="{ path: 'users' }">Пользователи</router-link></li>
              <li :class='active_tab_class("tests")'><router-link :to="{ path: 'tests' }">Тесты</router-link></li>
              <li :class='active_tab_class("devices")'><router-link :to="{ path: 'devices' }">Устройства</router-link></li>
              <li :class='active_tab_class("cars")'><router-link :to="{ path: 'cars' }">Машины</router-link></li>
              <li :class='active_tab_class("stats")'><router-link :to="{ path: 'stats' }">Статистика</router-link></li>
            </ul>
          </div>
        </nav>
      </div>

    </section>

    <router-view></router-view>
  
    <transition name="fade">
      <div class='back-overlay' v-show='login_overlay'></div>
    </transition>

    <b-modal :active.sync="is_waiting_for_card" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          Приложите карту к считывателю
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import loginFormModal from './components/loginFormModal'
// import store from './store'
import router from './router/index'
import { EventBus } from './bus'

export default {
  name: 'app',
  data: function () {
    this.is_logged_in()
    EventBus.$on('ws_on_message', this.ws_on_message)
    return {
      active_tab: 'Stats',
      login_overlay: true,
      navigation: '',
      current_user: '',
      is_waiting_for_card: false
      // store: store
    }
  },
  methods: {
    active_tab_class: function (name) {
      if (name === this.active_tab) return 'is-active'
      return ''
    },
    is_logged_in: function () {
      var t = this
      t.login_overlay = true
      var form = JSON.stringify({method: 'is_logged_in', params: {}})
      window.$.post(window.gw + 'api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'error') {
          router.push('home')
          t.$modal.open({
            parent: this,
            component: loginFormModal,
            hasModalCard: true,
            canCancel: false,
            props: {
              success: t.login_success
            }
          })
        } else {
          t.current_user = d.params.username
          t.login_overlay = false
        }
      })
    },
    login_success: function () {
      this.is_logged_in()
      // setTimeout(function () { location.reload() }, 500)
    },
    logout: function () {
      // var t = this
      var form = JSON.stringify({method: 'logout', params: {}})
      window.$.post(window.gw + 'api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') location.reload()
      })
    },
    ws_on_message: function (message) {
      console.log('App', 'ws_on_message', message)
      message = JSON.parse(message)
      var method = message.method
      var params = message.params
      if (method === 'handshake') this.ws_handshake()
      if (method === 'set_device_id') this.ws_set_device_id(params)
      if (method === 'ping') this.ws_send_ping()
    },
    ws_handshake: function () {
      var c = {method: 'handshake', params: {'device_type': 'admin', 'version': window.version}}

      if (localStorage.getItem('device_id')) {
        c.params.device_id = localStorage.getItem('device_id')
      }

      this.$socket.send(JSON.stringify(c))
      console.log(c)
      c = {method: 'page_change', params: {'from': this.$route.path, 'to': this.$route.path}}
      this.$socket.send(JSON.stringify(c))
      console.log(c)
    },
    ws_set_device_id: function (params) {
      localStorage.setItem('device_id', params.device_id)
    },
    ws_send_ping: function () {
      var c = {method: 'ping', params: {}}
      this.$socket.send(JSON.stringify(c))
    }
  }
}
</script>

<style>
#app {
}

.upload-draggable {
  width: 100%;
  height: 40px;
}

.is-margin-top {
  margin-top: 10px;
}

.tab-content {
  overflow: visible !important;
}

</style>

<style lang='scss'>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
$primary: $twitter;
$primary-invert: findColorInvert($primary);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": ($white, $black),
  "black": ($black, $white),
  "light": ($light, $light-invert),
  "dark": ($dark, $dark-invert),
  "primary": ($primary, $primary-invert),
  "info": ($info, $info-invert),
  "success": ($success, $success-invert),
  "warning": ($warning, $warning-invert),
  "danger": ($danger, $danger-invert),
  "twitter": ($twitter, $twitter-invert)
  );

.dropdown-item {
  color: black !important;
}

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

.back-overlay {
  position: fixed;
  background-color: white;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
.hero-foot {
  margin-top: -40px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue